import { css } from 'emotion'

export const FeedbackFormStyles = css``
